import { Reducer } from 'redux';

import { ActionType } from '../../../store/actionTypes';
import { EntityAction, ErrorAction, Action as PlainAction } from '../../types';

export interface UsersState {
  // users: Array<{Id: number, Email: string}>;
  users: any;
  isFetchingUsers: boolean;
  usersFetchingError: string | null;
}

export const initialState: UsersState = {
  users: null,
  isFetchingUsers: true,
  usersFetchingError: null,
};

type Action =
  | PlainAction<ActionType.FETCH_USER_LIST_STARTED>
  | EntityAction<ActionType.FETCH_USER_LIST_SUCCEEDED>
  | ErrorAction<ActionType.FETCH_USER_LIST_FAILED>;

export const userReducer: Reducer<UsersState, Action> = (
  state: UsersState = initialState,
  action: Action,
) => {
  switch (action.type) {
    case ActionType.FETCH_USER_LIST_STARTED:
      return {
        ...state,
        isFetchingUsers: true,
        usersFetchingError: null,
      };
    case ActionType.FETCH_USER_LIST_SUCCEEDED:
      return {
        ...state,
        isFetchingUsers: false,
        usersFetchingError: null,
        users: action.payload.entities.users,
      };
    case ActionType.FETCH_USER_LIST_FAILED:
      return {
        ...state,
        isFetchingUsers: false,
        usersFetchingError: action.payload.message,
      };
    default:
      return state;
  }
};

export default userReducer;
